export default "__VITE_ASSET__aTLtTu6p__"